(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-description')) {
    customElements.define('collection-description', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.content = this.querySelector('.collection-description__content');
        this.observer = new ResizeObserver(([entry]) => {
          if (entry.contentRect.width !== this.lastWidth) {
            this.lastWidth = entry.contentRect.width;
            this.scheduleMeasurement();
          }
        });
        this.observer.observe(this);
        this.onLoad = (event) => {
          if (this.content.contains(event.target)) this.scheduleMeasurement();
        };
        this.addEventListener('load', this.onLoad, true);
        document.fonts.ready.then(() => {
          if (this.isConnected) this.scheduleMeasurement();
        });
      }

      disconnectedCallback() {
        this.observer.disconnect();
        this.removeEventListener('load', this.onLoad, true);
        cancelAnimationFrame(this.frame);
        this.lastWidth = undefined;
      }

      scheduleMeasurement() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      }

      measure() {
        if (!this.isConnected || !this.clientWidth) return;
        const probe = this.content.cloneNode(true);
        probe.classList.add('collection-description__measurement');
        probe.setAttribute('aria-hidden', 'true');
        probe.inert = true;
        probe.removeAttribute('id');
        probe.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        this.append(probe);
        const style = getComputedStyle(probe);
        const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.5;
        const fits = probe.getBoundingClientRect().height <= lineHeight + 1
          && probe.scrollWidth <= probe.clientWidth + 1;
        probe.remove();
        if (fits && !this.hasAttribute('data-single-line')) {
          this.wasOpen = this.details.open;
          this.setAttribute('data-single-line', '');
          this.details.open = true;
        } else if (!fits && this.hasAttribute('data-single-line')) {
          this.removeAttribute('data-single-line');
          this.details.open = this.wasOpen;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
